// extracted by extract-css-chunks-webpack-plugin
module.exports = {"select":"_1bABNd","iconWrapper":"_3bICHo"};